import * as types from './mutation-types'

export const membershipGetMemberships = ({ commit, state }, options) => {
  options = _.merge({
    params: {
      per_page: 100,
    },
  }, options)

  return Vue2.prototype.$api.active().get('memberships', {
    params: options.params,
  }).then((response) => {
    if(options.params.page && options.params.page > 1) {
      Vue2.set(state.membership.memberships,'data', state.membership.memberships.data.concat(response.data.data))
      Vue2.set(state.membership.memberships,'meta', response.data.meta)
      Vue2.set(state.membership.memberships,'_links', response.data._links)
    } else {
      commit(types.MEMBERSHIP_SET_MEMBERSHIPS, response.data)
    }
    return response
  })
}

export const membershipGetMembership = ({ commit }, options) => {
  options = _.extend({
    params: { include: 'customMembershipFields' },
  }, options)

  return Vue2.prototype.$api.active().get(`memberships/${options.membershipUuid}`, {
    params: options.params,
  }).then((response) => {
    commit(types.MEMBERSHIP_SET_MEMBERSHIP, response.data)
    return response
  })
}

export const membershipUpdateMembership = ({ commit }, { membershipUuid, data }) => {
  return Vue2.prototype.$api.active().put(`memberships/${membershipUuid}`, data).then((response) => {
    commit(types.MEMBERSHIP_SET_MEMBERSHIP, response.data)
    return response
  })
}

export const membershipGetCommunicableMemberships = ({ commit }, options = {}) => {
  return Vue2.prototype.$api.active().get('memberships/communicable')
    .then((response) => {
      commit(types.MEMBERSHIP_SET_MEMBERSHIPS, response.data)
      return response
    })
}

export const membershipGetMembershipGroups = ({ commit, state }, options = {}) => {
  options = _.merge({
    params: {
      per_page: 100,
    },
  }, options)

  return Vue2.prototype.$api.active().get('memberships/membership-groups', {
    params: options.params,
  }).then((response) => {
    if(options.params.page && options.params.page > 1) {
      Vue2.set(state.membership.membershipGroups,'data', state.membership.membershipGroups.data.concat(response.data.data))
      Vue2.set(state.membership.membershipGroups,'meta', response.data.meta)
      Vue2.set(state.membership.membershipGroups,'_links', response.data._links)
    } else {
      commit(types.MEMBERSHIP_SET_MEMBERSHIP_GROUPS, response.data)
    }
  })
}

export const membershipCreateMembershipGroup = ({ commit }, payload) => {
  return Vue2.prototype.$api.active().post(`memberships/membership-groups`, payload).then((response) => {
    commit('baseAddNotification', {
      type: 'success',
      text: 'Group has been created.',
      timeout: false,
    })
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'There was an error creating the group.',
      timeout: false,
    })
    reject(errors)
  })
}

export const membershipAssignMembershipGroups = ({ commit }, { membershipUuid, payload }) => {
  return Vue2.prototype.$api.active().post(`memberships/${membershipUuid}/membership-groups`, payload).then((response) => {
    if (response.data.status === 'success') {
      commit('baseAddNotification', {
        type: 'success',
        text: response.data.message,
      })
    } else {
      commit('baseAddNotification', {
        type: 'error',
        text: response.data.message,
        timeout: false,
      })
    }
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'An error has occurred.',
      timeout: false,
    })
    reject(errors)
  })
}

export const membershipDeleteMembershipGroup = ({ commit }, membershipGroup) => {
  return Vue2.prototype.$api.active().delete(`memberships/membership-groups/${membershipGroup}`).then((response) => {
    commit('baseAddNotification', {
      type: 'sucess',
      text: 'Group has been deleted.',
      timeout: false,
    })
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'There was an error deleting the group.',
      timeout: false,
    })
    reject(errors)
  })
}

export const membershipGetMembershipGroupTypes = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('memberships/membership-groups/types')
      .then((response) => {
        commit(types.MEMBERSHIP_SET_MEMBERSHIP_GROUP_TYPES, response.data)
        resolve()
      })
  })
}

export const membershipGetPendingAccessRequests = ({ commit }, options) => {
  options = _.extend({
    params: {},
  }, options)

  options.params.include = 'membership.phoneNumbers,membership.membershipGroups'
  options.params.per_page = 100

  return Vue2.prototype.$api.active().get('membership/access-requests', {
    params: options.params,
  }).then((response) => {
    commit(types.MEMBERSHIP_SET_PENDING_ACCESS_REQUESTS, response.data)
  })
}

export const membershipSubmitAccessRequestApprovalQueue = ({ commit, state }) => {
  let payload = _.map(state.membership.accessRequestApprovalQueue, function (AccessRequest) {
    return {
      access_request_uuid: AccessRequest.uuid,
      role_id: AccessRequest.role.id,
      membership_groups: _.map(AccessRequest.membership.membershipGroups.data, 'uuid'),
    }
  })

  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().post('membership/access-requests/approve', payload)
      .then((response) => {
        commit('membershipResetPendingAccessRequestQueue')
        resolve()
      }).catch((errors) => {
        reject()
      })
  })
}

/**
 * @param commit
 * @param state
 * @param dispatch
 * @param payload
 * @return Promise
 */
export const membershipRunMembershipReport = ({ commit, state, dispatch }, payload) => {
  return Vue2.prototype.$api.active().post(payload.url, payload.parameters)
    .then((response) => {
      commit('baseAddNotification', {
        type: 'success',
        text: response.data.message,
        timeout: false,
      })
      return response
    })
    .catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error building your report.',
        timeout: false,
      })
    })
}

/**
 * @param commit
 * @return Promise
 */
export const membershipGetMembershipReports = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('memberships/reports').then(({ data }) => {
      commit('membershipSetMembershipReports', data.data)
      resolve(data)
    }).catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error fetching the reports.',
        timeout: false,
      })

      reject(errors)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const membershipGetAvailableReportColumns = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('memberships/reports/available-columns').then(({ data }) => {
      commit('membershipSetAvailableReportColumns', data)
      resolve(data)
    }).catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error fetching the available report columns.',
        timeout: false,
      })

      reject(errors)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const membershipGetAvailableReportFilters = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('memberships/reports/available-filters').then(({ data }) => {
      commit('membershipSetAvailableReportFilters', data.data)
      resolve(data)
    }).catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error fetching the available report filters.',
        timeout: false,
      })

      reject(errors)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const membershipDeleteMembershipReport = ({ commit }, membershipReportUuid) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().delete(`memberships/reports/${membershipReportUuid}`).then(({ data }) => {
      resolve(data)
    }).catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error deleting the report.',
        timeout: false,
      })

      reject(errors)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const membershipGetMembershipReport = ({ commit }, membershipReportUuid) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get(`memberships/reports/${membershipReportUuid}`).then(({ data }) => {
      commit(types.MEMBERSHIP_SET_MEMBERSHIP_REPORT, data)
      resolve(data)
    }).catch((errors) => {
      commit(types.MEMBERSHIP_SET_MEMBERSHIP_REPORT, {})
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error fetching the report.',
        timeout: false,
      })

      reject(errors)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const membershipExportMembershipData = ({ commit }) => {
  return Vue2.prototype.$api.active().post('memberships/export').then((response) => {
    commit('baseAddNotification', {
      type: 'success',
      text: 'Membership data is compiling. Please check back later to download file.',
      timeout: false,
    })
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'There was an error compiling membership data.',
      timeout: false,
    })
  })
}
